import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MenuItem, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { GetScholarshipRequest, ScholarshipType, ScholarshipTypeDescriptions } from '../../models/scholarships/getScholarshipRequest';
import { ScholarshipsService } from '../../services/scholarships/scholarships.service';
import { ScholarshipResponse } from '../../models/scholarships/scholarshipResponse';
import { AddScholarshipRequest, UpdateScholarshipRequest } from '../../models/scholarships/addScholarshipRequest';
import { FileSelectEvent, FileUpload, FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { ToastModule } from 'primeng/toast';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { InputSwitchChangeEvent, InputSwitchModule } from 'primeng/inputswitch';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ImageCropUploadComponent } from '../../utility/image-crop-upload/image-crop-upload.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { DeadLineDetails, EligibilityDetails, InternalDetails, ScholarshipAmountDetails } from '../../models/scholarships/addScholarshipRequest';
import { DeadlinePipe } from '../../pipe/deadlinePipe';


interface ColumnConfig {
  field: string;
  header: string;
  visible: boolean;
  width?: string;
}

@Component({
  selector: 'app-add-scholarships',
  standalone: true,
  imports: [TableModule, FormsModule, ReactiveFormsModule, InputTextModule, ToastModule, InputTextareaModule,
    DropdownModule, ButtonModule, DialogModule, CommonModule, DeadlinePipe, FileUploadModule, AutoCompleteModule, 
    MenuModule, InputSwitchModule, OverlayPanelModule, ImageCropUploadComponent,
    MultiSelectModule, CalendarModule, CheckboxModule, ChipsModule
  ],

  templateUrl: './add-scholarships.component.html',
  styleUrl: './add-scholarships.component.scss'
})
export class AddScholarshipsComponent implements OnInit, AfterViewInit{

  @ViewChild('fileUploader') fileUploader!: FileUpload;
  @ViewChild('streamDropdown', { read: ElementRef }) streamDropdownRef!: ElementRef;
  streamDropdownWidth = 0;

  constructor(private formBuilder: FormBuilder, private messageService: MessageService,
    private scholarshipsService: ScholarshipsService, private cdr: ChangeDetectorRef
  ){}

  columns: ColumnConfig[] = [
    { field: 'schoolName', header: 'Scholarship Name', visible: true },
    { field: 'image', header: 'Image', visible: true },
    { field: 'type', header: 'Type', visible: true },
    { field: 'description', header: 'Description', visible: true },
    { field: 'eligibility', header: 'Eligibility', visible: true },
    { field: 'deadline', header: 'Deadline', visible: true },
    { field: 'startDate', header: 'Start Date', visible: true },
    { field: 'scholarshipAmount', header: 'Scholarship Amount', visible: true },
    { field: 'stream', header: 'Stream', visible: true },
    { field: 'level', header: 'Level', visible: true },
    { field: 'applicationLink', header: 'Application Link', visible: true },
    { field: 'internal.sourceUrl', header: 'Internal Source URL', visible: false },

    { field: 'actions', header: 'Actions', visible: true }
  ];

  columnMenuItems: MenuItem[] = [];
  readonly STORAGE_KEY = 'scholarship-list-column-config';
    
  totalRecords: number = 0;
  first: number = 0;
  rowSize: number = 10;
  pageSize = 10;

  filterForm!: FormGroup;
  newScholarshipForm!: FormGroup;
  streamOptions: string[] = [];

  levelOptions: any[] = [];
  mappedStreamOptions: any[] = [];
  mappedLevelOptions: any[] = [];

  schoplarshipNames: string[] = [];
  scholarshipOptions = [
    {name: ScholarshipTypeDescriptions[ScholarshipType.Scholarship], value: 0},
    {name: ScholarshipTypeDescriptions[ScholarshipType.ProfileBuilding], value: 1},
    {name: ScholarshipTypeDescriptions[ScholarshipType.SummerSchoolIndia], value: 2},
    {name: ScholarshipTypeDescriptions[ScholarshipType.SummerSchoolAbroad], value: 3},
  ]
  
  monthOptions = [
    { label: 'January', value: 'Jan' }, { label: 'February', value: 'Feb' },
    { label: 'March', value: 'Mar' }, { label: 'April', value: 'Apr' },
    { label: 'May', value: 'May' }, { label: 'June', value: 'Jun' },
    { label: 'July', value: 'Jul' }, { label: 'August', value: 'Aug' },
    { label: 'September', value: 'Sep' }, { label: 'October', value: 'Oct' },
    { label: 'November', value: 'Nov' }, { label: 'December', value: 'Dec' },
    { label: 'Rolling', value: 'Rolling' }, { label: 'Varies', value: 'Varies' }
  ];

  currencyOptions = [
    { label: 'USD ($)', value: 0 },
    { label: 'Rupee (₹)', value: 1 },
    { label: 'Euro (€)', value: 2 },
    { label: 'Pound (£)', value: 3 }
  ];

  fundingTypeOptions = [
    { label: 'Full Funding', value: 'Full Funding' },
    { label: 'Partial Funding', value: 'Partial Funding' },
    { label: 'Tuition Fee Waiver', value: 'Tuition Fee Waiver' },
    { label: 'Stipend', value: 'Stipend' },
    { label: 'Accommodation', value: 'Accommodation' },
    { label: 'Travel Grant', value: 'Travel Grant' }
  ];

  countryOptions: any[] = [];
  
  scholarshipsList: ScholarshipResponse[] = [];

  scholarshipToEdit: ScholarshipResponse | null = null;
  attachment: File | Blob | undefined;
  uploadedImageUrl: string | null | undefined;
  submitted = false;
  isLoading = false;
  isVisible = false;

  currentDeadlineIndex = 0;
  currentStartDateIndex = 0;
  deadlinesResponse: string[] = [];
  startDatesResponse: string[] = [];

  ngOnInit(): void {
    this.initializeForm();
    this.loadColumnConfiguration();
    this.getStreamOrLevelOptions();
    this.getScholarships(1);
    this.getCountryOptions();
  }


  ngAfterViewInit(): void {
    // measure after view init; dropdown trigger may not be present immediately when hidden
    setTimeout(() => this.setStreamDropdownWidth(), 50);
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.setStreamDropdownWidth();
  }

  private setStreamDropdownWidth(): void {
    try {
      const el = this.streamDropdownRef?.nativeElement as HTMLElement | undefined;
      if (el) {
        // p-dropdown trigger has nested structure; get bounding width of the host element
        const w = el.getBoundingClientRect().width || el.offsetWidth || 0;
        this.streamDropdownWidth = Math.max(0, Math.round(w));
        this.cdr.detectChanges();
      }
    } catch (err) {
      // ignore measurement errors
    }
  }

  private loadColumnConfiguration(): void {
    try {
      const savedConfig = localStorage.getItem(this.STORAGE_KEY);
      if (savedConfig) {
        const parsedConfig = JSON.parse(savedConfig);
        this.columns = this.columns.map(col => {
          const savedCol = parsedConfig.find((c: ColumnConfig) => c.field === col.field);
          return savedCol ? { ...col, visible: savedCol.visible } : col;
        });
      }
    } catch (error) {
      console.warn('Error loading column configuration:', error);
    }
  }
  // Save column configuration to localStorage
  private saveColumnConfiguration(): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.columns));
    } catch (error) {
      console.warn('Error saving column configuration:', error);
    }
  }
  // Toggle column visibility
  toggleColumnVisibility(field: string): void {
    const column = this.columns.find(col => col.field === field);
    if (column) {
      column.visible = !column.visible;
      this.saveColumnConfiguration();
      this.updateColumnMenu();
    }
  }
  // Handle column visibility change from InputSwitch
  onColumnVisibilityChange(event: InputSwitchChangeEvent, field: string): void {
      const column = this.columns.find(col => col.field === field);
      if (column) {
        column.visible = event.checked;
        this.saveColumnConfiguration();
        this.updateColumnMenu();
      }
    }
  get visibleColumns(): ColumnConfig[] {
    return this.columns.filter(col => col.visible);
  }
  // Update column menu items
  private updateColumnMenu(): void {
    this.columnMenuItems = this.columns.map(col => ({
      label: col.header,
      icon: col.visible ? 'pi pi-eye' : 'pi pi-eye-slash',
      command: () => this.toggleColumnVisibility(col.field),
      styleClass: col.visible ? 'text-green-600' : 'text-gray-400'
    }));
  }

  // Reset column configuration to default
  resetColumnConfiguration(): void {
    this.columns = this.columns.map(col => ({ ...col, visible: true }));
    this.saveColumnConfiguration();
    this.updateColumnMenu();
  }
  isColumnVisible(field: string): boolean {
    const column = this.columns.find(col => col.field === field);
    return column?.visible ?? false;
  }

 // Export current column configuration
  exportColumnConfiguration(): void {
    const config = {
      columns: this.columns,
      exportedAt: new Date().toISOString(),
      totalColumns: this.columns.length,
      visibleColumns: this.visibleColumns.length
    };

    const blob = new Blob([JSON.stringify(config, null, 2)], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `student-list-column-config-${new Date().toISOString().split('T')[0]}.json`;
    a.click();
    window.URL.revokeObjectURL(url);

    this.messageService.add({
      severity: 'success',
      summary: 'Configuration Exported',
      detail: 'Column configuration has been exported successfully.'
    });
  }

  // Import column configuration
  importColumnConfiguration(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        try {
          const config = JSON.parse(e.target.result);
          if (config.columns && Array.isArray(config.columns)) {
            this.columns = config.columns;
            this.saveColumnConfiguration();
            this.updateColumnMenu();
            this.messageService.add({
              severity: 'success',
              summary: 'Configuration Imported',
              detail: 'Column configuration has been imported successfully.'
            });
          }
        } catch (error) {
          this.messageService.add({
            severity: 'error',
            summary: 'Import Failed',
            detail: 'Invalid configuration file format.'
          });
        }
      };
      reader.readAsText(file);
    }
  }

  typeDescriptions(arg0: ScholarshipType ): string {
    return ScholarshipTypeDescriptions[arg0];
  }

  getStreamOrLevelOptions(){
    this.getStreamOptions();
    this.getLevelOptions();
  }

  getStreamOptions(){
    this.scholarshipsService.getStream().subscribe({
      next: (response) => {
        this.streamOptions = response.result;
        this.mappedStreamOptions = response.result.map((s: string) => ({ label: s, value: s }));
      },
      error: (err) => {
        console.warn('Error fetching stream options:' , err)
      }
    })
  }
  getLevelOptions(){
    this.scholarshipsService.getLevel().subscribe({
      next: (response) => {
        this.levelOptions = response.result;
        this.mappedLevelOptions = response.result.map((l: string) => ({ label: l, value: l }));
      },
      error: (err) => {
        console.warn('Error fetching level options:' , err)
      }
    })
  }


  getCountryOptions() {
    this.scholarshipsService.getCountry().subscribe({
      next: (response) => {
        this.countryOptions = response.result.map((c: string) => ({ label: c, value: c }));
      }
    });
  }


  filterScholarshipNames(event: AutoCompleteCompleteEvent){
    if(event.query.length > 3){
      this.scholarshipsService.listScholarShipsName_ByInitials(event.query).subscribe({
        next: (response) => {
          this.schoplarshipNames = response.result;
        }
      });
    }else{
      this.schoplarshipNames = [];
    }
  }

  initializeForm(){
    this.filterForm = this.formBuilder.group({
      scholarshipName: [''],
      scholarshipType: [null],
      stream: [null],
      level: [null]
    });

    this.newScholarshipForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: [''],
      country: [[]],
      universityOrOrganisationName: [''],
      stream: [[]],
      level: [''],
      fundingType: [[]],
      applicationLink: ['', [Validators.pattern('^(https?://.+)?$')]],
      
      eligibility: this.formBuilder.group({
        academicRequirements: [''],
        testRequirements: [''],
        nationality: [''],
        age: [''],
        others: ['']
      }),

      deadLine: this.formBuilder.group({
        month: [''],
        exactDate: ['']
      }),

      scholarship: this.formBuilder.group({
        exactNumbersUnavailable: [''],
        amount: this.formBuilder.array([])
      }),

      internal: this.formBuilder.group({
        lastVerifiedDate: [null],
        sourceUrl: [''],
        notes: ['']
      }),

      // Legacy/Misc
      scholarshipType: [null],
      image: [null]
    });
  }


  getScholarshipImage(image: string | null | undefined): string | null {
    if (!image) return null;
    const img = image.trim();
    if (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('data:')) {
      return img;
    }
    return null;
  }

  populateScholarshipForm() {
    if (this.scholarshipToEdit) {
      this.uploadedImageUrl = this.getScholarshipImage(this.scholarshipToEdit.image);
      let rawLink = (this.scholarshipToEdit.applicationLink ?? '').trim();
if (rawLink && !/^https?:\/\//i.test(rawLink)) {
  rawLink = `https://${rawLink}`;
}
      this.newScholarshipForm.patchValue({
        name: this.scholarshipToEdit.name,
        description: this.scholarshipToEdit.description,
        country: this.scholarshipToEdit.country,
        universityOrOrganisationName: this.scholarshipToEdit.universityOrOrganisationName,
        stream: this.scholarshipToEdit.stream,
        level: this.scholarshipToEdit.level,
        fundingType: this.scholarshipToEdit.fundingType,
        applicationLink: rawLink,
        scholarshipType: this.scholarshipToEdit.scholarshipType
      });

      if (this.scholarshipToEdit.eligibility) {
        this.newScholarshipForm.get('eligibility')?.patchValue(this.scholarshipToEdit.eligibility);
      }

      if (this.scholarshipToEdit.deadLine) {
        const dl = { ...this.scholarshipToEdit.deadLine };
        if (dl.month) {
          const monthMap: { [key: string]: string } = {
            'january': 'Jan', 'february': 'Feb', 'march': 'Mar', 'april': 'Apr',
            'june': 'Jun', 'july': 'Jul', 'august': 'Aug', 'september': 'Sep',
            'october': 'Oct', 'november': 'Nov', 'december': 'Dec'
          };
          const normalized = monthMap[dl.month.toLowerCase()];
          if (normalized) {
            dl.month = normalized;
          }
        }
        this.newScholarshipForm.get('deadLine')?.patchValue(dl);
      }

      if (this.scholarshipToEdit.internal) {
        const internal = { ...this.scholarshipToEdit.internal };
        if (internal.lastVerifiedDate) {
          internal.lastVerifiedDate = new Date(internal.lastVerifiedDate) as any;
        }
        this.newScholarshipForm.get('internal')?.patchValue(internal);
      }

      if (this.scholarshipToEdit.scholarship) {
        const scholarshipGroup = this.newScholarshipForm.get('scholarship') as FormGroup;
        scholarshipGroup.patchValue({
          exactNumbersUnavailable: this.scholarshipToEdit.scholarship.exactNumbersUnavailable === 'true'
        });

        const amountArray = scholarshipGroup.get('amount') as FormArray;
        amountArray.clear();
        this.scholarshipToEdit.scholarship.amount?.forEach(amt => {
          amountArray.push(this.formBuilder.group({
            currency: [amt.currency],
            amount: [amt.amount]
          }));
        });
      }
    }
  }

  get scholarshipAmountArray(): FormArray {
    return this.newScholarshipForm.get('scholarship.amount') as FormArray;
  }

  addAmount() {
    this.scholarshipAmountArray.push(this.formBuilder.group({
      currency: [null],
      amount: ['']
    }));
  }

  removeAmount(index: number) {
    this.scholarshipAmountArray.removeAt(index);
  }

  



  removeScholarship(scholarshipid: number){
    this.isLoading = true;
    this.scholarshipsService.deleteScholarShipRequest(scholarshipid).subscribe({
      next: (response) => {
        this.scholarshipsList = this.scholarshipsList.filter(s => s.id !== scholarshipid);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error deleting scholarship:', err);
        this.isLoading = false;
      }
    })
  }

  getScholarships(pageNumber: number){
    this.isLoading = true;
    const req: GetScholarshipRequest = {
      scholarshipName: this.filterForm.value.scholarshipName ,
      scholarshipType: this.filterForm.value.scholarshipType,
      stream: this.filterForm.value.stream,
      level: this.filterForm.value.level,
      pageNumber: pageNumber,
      pageSize: this.rowSize
    }
    this.scholarshipsService.getScholarships(req).subscribe({
      next: (response) => {
        if(response){
          this.scholarshipsList = response.result;
          this.totalRecords = response.total;
          this.isLoading = false;
        }else{
          this.scholarshipsList = [];
          this.totalRecords = 0;
          this.isLoading = false;
        } 
      },
      error: (err) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `Error Fetching Scholarships: ${err}` });
      }
    })
  }

  addNewScholarship(){
    this.isLoading = true;
    this.submitted = true;

    if (this.newScholarshipForm.invalid) {
      this.isLoading = false;
      return;
    }

    const processRequest = (attachmentBase64: string | null) => {
      const formValue = this.newScholarshipForm.value;
      const req: AddScholarshipRequest = {
        name: formValue.name,
        description: formValue.description,
        country: formValue.country,
        universityOrOrganisationName: formValue.universityOrOrganisationName,
        stream: formValue.stream,
        level: formValue.level,
        fundingType: formValue.fundingType,
        applicationLink: formValue.applicationLink,
        eligibility: formValue.eligibility,
        deadLine: formValue.deadLine,
        scholarship: {
          ...formValue.scholarship,
          exactNumbersUnavailable: formValue.scholarship.exactNumbersUnavailable?.toString()
        },
        internal: {

          ...formValue.internal,
          lastVerifiedDate: formValue.internal.lastVerifiedDate ? formValue.internal.lastVerifiedDate.toISOString() : null
        },
        scholarshipType: formValue.scholarshipType,
        image: attachmentBase64
      };

      this.scholarshipsService.addScholarship(req).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.submitted = false;
          if(response){
            this.scholarshipsList.unshift(response);
            this.closeDialog();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Scholarship added successfully' });
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error adding scholarship' });
        }
      })
    };


    if (this.attachment) {
      this.convertBlobToBase64(this.attachment).then((result) => {
        processRequest(result);
      }).catch(() => {
        this.isLoading = false;
      });
    } else {
      processRequest(null);
    }
  }

  updateScholarship(scholarshipid: number){
    this.isLoading = true;
    this.submitted = true;

    if (this.newScholarshipForm.invalid) {
      this.isLoading = false;
      return;
    }

    const processRequest = (attachmentBase64: string | null) => {
      const formValue = this.newScholarshipForm.value;
      const req: UpdateScholarshipRequest = {
        id: scholarshipid,
        name: formValue.name,
        description: formValue.description,
        country: formValue.country,
        universityOrOrganisationName: formValue.universityOrOrganisationName,
        stream: formValue.stream,
        level: formValue.level,
        fundingType: formValue.fundingType,
        applicationLink: formValue.applicationLink,
        eligibility: formValue.eligibility,
        deadLine: formValue.deadLine,
        scholarship: {
          ...formValue.scholarship,
          exactNumbersUnavailable: formValue.scholarship.exactNumbersUnavailable?.toString()
        },
        internal: {

          ...formValue.internal,
          lastVerifiedDate: formValue.internal.lastVerifiedDate ? 
            (formValue.internal.lastVerifiedDate instanceof Date ? formValue.internal.lastVerifiedDate.toISOString() : formValue.internal.lastVerifiedDate) 
            : null
        },
        scholarshipType: formValue.scholarshipType,
        image: attachmentBase64
      };

      this.scholarshipsService.updateScholarship(req).subscribe({
        next: () => {
          this.isLoading = false;
          this.submitted = false;
          this.closeDialog();
          this.getScholarships(1);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Scholarship updated successfully' });
      },
        error: (err) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error updating scholarship' });
        }
      })
    }


    if (this.attachment) {
      this.convertBlobToBase64(this.attachment).then((result) => {
        processRequest(result);
      }).catch(() => {
        this.isLoading = false;
      });
    } else {
      processRequest(null);
    }
  }

  upsertScholarship(){
    if(this.scholarshipToEdit){
      this.updateScholarship(this.scholarshipToEdit.id);
    }else{
      this.addNewScholarship();
    }
  }

  onDialogVisibilityChange(visible: boolean) {
    if (!visible) {
      this.newScholarshipForm.reset();
      this.scholarshipToEdit = null;
      this.attachment = undefined;
      this.uploadedImageUrl = null;
    }
  }

  addScholarshipDialog(scholarship?: ScholarshipResponse){
    if(scholarship){
      this.isLoading = true;
      this.scholarshipsService.getScholarshipById(scholarship.id).subscribe({
        next: (fullScholarship) => {
          this.scholarshipToEdit = fullScholarship;
          this.populateScholarshipForm();
          this.isVisible = true;
          this.isLoading = false;
        },
        error: (err) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch scholarship details.' });
        }
      });
    }else{
      this.scholarshipToEdit = null;
      this.isVisible = true;
      this.attachment = undefined;
      this.uploadedImageUrl = null;
    }
  }

  closeDialog() {
    this.isVisible = false;
    this.newScholarshipForm.reset();
    this.scholarshipToEdit = null;
    this.attachment = undefined;
    this.uploadedImageUrl = null;
  }

  onLazyLoad($event: TableLazyLoadEvent): void {
    const pageNumber = Math.floor(($event.first ?? 0) / ($event.rows ?? this.rowSize)) + 1;
    this.first = $event.first ?? 0;
    this.rowSize = $event.rows ?? this.rowSize;
    this.getScholarships(pageNumber);
  }

  convertBlobToBase64(file: File | Blob | undefined): Promise<string>{
    return new Promise((resolve, reject) => {
      if(!file){
        reject('No file provided');
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result as string)
      }
      reader.onerror = (error) => {
        reject('Error reading file: '+ error);
      }
    })
  }

  onScholarshipImageCropped(base64: string) {
    // Update preview and convert to File for upload
    this.uploadedImageUrl = base64;
    this.attachment = this.dataURLtoFile(base64, 'scholarship.png');
  }

  dataURLtoFile(dataUrl: string, filename: string): File {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  }
}
